import { api } from '@/lib/axios';
import type { ScanRule, ScanRuleTestResult } from '../types/time-scan.types';

// ── AP-14-B: Scan-Regeln ──────────────────────────────────────────────────────
// Die Regeln liegen in der Zeiterfassungs-Config (TenantTimeConfig.scanRules) und
// werden über die bestehenden Config-Endpunkte gelesen/geschrieben — kein
// eigenes CRUD, damit es nur eine Wahrheitsquelle für die Einstellungen gibt.

export async function getScanRules(): Promise<ScanRule[]> {
  const res = await api.get<{ scanRules?: unknown }>('/time-config');
  const raw = res.data?.scanRules;
  return Array.isArray(raw) ? (raw as ScanRule[]) : [];
}

export async function saveScanRules(rules: ScanRule[]): Promise<ScanRule[]> {
  const res = await api.patch<{ scanRules?: unknown }>('/time-config', { scanRules: rules });
  const raw = res.data?.scanRules;
  return Array.isArray(raw) ? (raw as ScanRule[]) : rules;
}

/** Testet einen Rohwert — mit `rules` auch den noch nicht gespeicherten Stand. */
export async function testScanRules(rawValue: string, rules?: ScanRule[]): Promise<ScanRuleTestResult> {
  const res = await api.post<{ data: ScanRuleTestResult }>('/time-tracking/scan/rules/test', {
    rawValue,
    ...(rules ? { rules } : {}),
  });
  return res.data.data;
}
